<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "bold";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M20.67 6.60093C21.0019 6.23091 20.971 5.6619 20.601 5.33001C20.2309 4.99812 19.6619 5.02902 19.33 5.39904L9.23638 16.6521L4.66999 11.5612C4.33809 11.1912 3.76908 11.1603 3.39907 11.4922C3.02905 11.8241 2.99815 12.3931 3.33004 12.7631L8.5664 18.6009C8.73711 18.7912 8.98071 18.9 9.23638 18.9C9.49204 18.9 9.73564 18.7912 9.90635 18.6009L20.67 6.60093Z"
    />
    <path
      v-else-if="weight === 'bold'"
      d="M21.1166 7.00159C21.6698 6.3849 21.6183 5.43655 21.0016 4.88339C20.3849 4.33024 19.4365 4.38174 18.8834 4.99844L9.23638 15.7536L5.11664 11.1606C4.56348 10.5439 3.61513 10.4924 2.99844 11.0456C2.38174 11.5987 2.33024 12.5471 2.88339 13.1638L8.11976 19.0016C8.40427 19.3188 8.81027 19.5 9.23638 19.5C9.66248 19.5 10.0685 19.3188 10.353 19.0016L21.1166 7.00159Z"
    />
  </svg>
</template>
